import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import AboutUs from "./components/AboutUs/AboutUs";
import Header from "./components/Header/header";
import Footer from "./components/Footer/footer";
import Telecom from "./components/grid/gridReadMore"
import Retail from "./components/Entreprise/RetailMore"
import Solution from "./components/Solution/Solution";
function App() {
  return (
    <Router>
        <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        {/* <Route path="/Solution" element={<Solution />} /> */}
        {/* <Route path="/Telecom" element={<Telecom />} /> */}
        {/* <Route path="/Retail" element={<Retail />} /> */}
      </Routes>
        <Footer />
    </Router>
  );
}

export default App;
